import { exists } from "./validation";

export const hasAdminRole = (u) => {
  if (u === undefined) return false;
  if (u.roles === undefined) return false;
  if (u.roles.length === 0) return false;
  for (let r of u.roles) {
    if ("ADMIN" === r) return true;
  }
  return false;
};

export const canEditClip = (user, clip) => {
  if (hasAdminRole(user)) return true; //Admin can edit all files
  if (!exists(user)) return false;
  if (!exists(clip)) return false;
  if(clip.createdBy)
  {
    return clip.createdBy.id === user.id;
  }
  return clip.afCase?.userId === user.id;
};

export const canEditCase = (user, af_case) => {
  if (hasAdminRole(user)) return true; //Admin can edit all files
  if (!exists(user)) return false;
  if (!exists(af_case)) return false;
  return af_case.createdBy?.id === user.id;
};
